<template>
  <div>
    <conversation-list list-type="deleted" />
  </div>
</template>

<script>
import ConversationList from '@/components/ConversationList.vue';

export default {
  metaInfo: {
    title: 'Deleted Messages',
  },
  components: {
    ConversationList,
  },
};
</script>
